import React, {useEffect, useState} from "react";
import {Container} from "react-bootstrap";
import {useHistory, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import FeatherIcon from "feather-icons-react";
import Skeleton from "react-loading-skeleton";
import useAxios from "../../utils/useAxios";
import {COUNTRY_OPTIONS, LEVEL_OPTIONS} from "../../constants";
import {getOptionName} from "../../utils/getOptionName";
import PlayerStatistic from "./PlayerStatistic";

const PlayerDetail = () => {
    const {t} = useTranslation();
    const api = useAxios();
    const history = useHistory();
    const {baseId, playerId} = useParams();

    const [player, setPlayer] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!baseId || !playerId) {
            history.replace("/404");
            return;
        }

        api.get(`/api/v1.0/players/${playerId}/?statistic=true`)
            .then(res => setPlayer(res.data))
            .catch(() => history.replace("/404"))
            .finally(() => setLoading(false));
    }, [baseId, playerId]);

    if (loading) {
        return (
            <Container className="page_container">
                <Skeleton height={200}/>
            </Container>
        );
    }

    const handleBack = () => {
        if (window.history.length > 1 && (history.action === "PUSH" || history.action === "REPLACE" || (document.referrer && document.referrer.includes(window.location.host)))) {
            history.goBack();
        } else {
            history.push(`/admin/bases/${baseId}/players`);
        }
    };

    return (
        <Container className="page_container">
            <nav className="tabs-container">
                <ul className="tabs">
                    <li>
                        <a href="#" onClick={(e) => {
                            e.preventDefault();
                            handleBack();
                        }}>
                            <FeatherIcon icon="arrow-left" size={16}/>
                        </a>
                    </li>
                    <li className="easy-black">
                        {player.last_name} {player.first_name}
                    </li>
                </ul>
            </nav>


            <div className="tournament-form" style={{marginTop: "15px"}}>
                <div>
                    <div className="content_page">
                        <table>
                            <tr>
                                <td>
                                    <div className="player-avatar">
                                        {player.image
                                            && <img src={player.image}/>
                                        }
                                    </div>
                                </td>
                                <td>
                                    <div className="player-detail-info">
                                            <div>
                                                {player.last_name} {player.first_name}
                                            </div>

                                            {player.city && (
                                                <div>
                                                    <strong>{t("City")}:</strong>{" "}
                                                    {player.city}
                                                    {player.country && `, ${t(getOptionName(COUNTRY_OPTIONS, player.country))}`}
                                                </div>
                                            )}

                                            {player.level && (
                                                <div>
                                                    <strong>{t("Level")}:</strong>{" "}
                                                    {t(getOptionName(LEVEL_OPTIONS, player.level))}
                                                </div>
                                            )}

                                            {player.email && (
                                                <div>
                                                    <strong>Email:</strong> {player.email}
                                                </div>
                                            )}

                                            {player.phone && (
                                                <div>
                                                    <strong>{t("Phone")}:</strong> {player.phone}
                                                </div>
                                            )}

                                            {player.phone && (
                                                <div>
                                                    <strong>{t("Matches")}:</strong> {player.statistic?.total_matches}
                                                </div>
                                            )}

                                            {player.phone && (
                                                <div>
                                                    <strong>{t("Win")}:</strong> {player.statistic?.wins}
                                                </div>
                                            )}

                                            {player.phone && (
                                                <div>
                                                    <strong>{t("Lose")}:</strong> {player.statistic?.losses}
                                                </div>
                                            )}
                                    </div>
                                </td>
                            </tr>
                </table>
                </div>
            </div>
                    <PlayerStatistic playerId={playerId} />
            </div>
        </Container>
    );
};

export default PlayerDetail;